import React, { useState } from 'react';

const SteganographyChallenge = ({ challenge }) => {
  const [userSolution, setUserSolution] = useState(''); // To track user input
  const [isCorrect, setIsCorrect] = useState(false); // To track correctness
  const [hasSubmitted, setHasSubmitted] = useState(false); // To track form submission

  const handleSubmit = (e) => {
    e.preventDefault();
    setHasSubmitted(true); // Mark as submitted

    // Check if the solution is correct
    if (userSolution === challenge.solution) {
      setIsCorrect(true);
    } else {
      setIsCorrect(false);
    }
  };

  return (
    <div>
      <p className="text-textWhite mb-4">{challenge.description}</p>
      <img
        src={challenge.resource}
        alt={challenge.name}
        className="max-w-full h-auto border border-cyberBlue rounded-lg"
      />
      <p className="mt-2 text-textWhite">Download the image and find the hidden message.</p>

      {/* Flag submission form */}
      <form onSubmit={handleSubmit} className="mt-4">
        <input
          type="text"
          value={userSolution}
          onChange={(e) => setUserSolution(e.target.value)}
          className="bg-gray-800 text-white p-2 rounded-lg"
          placeholder="Enter the flag"
        />
        <button type="submit" className="bg-cyberBlue text-black p-2 rounded-lg ml-2">
          Submit Flag
        </button>
      </form>

      {/* Show feedback only after the form has been submitted */}
      {hasSubmitted && (
        isCorrect ? (
          <p className="text-green-500 mt-2">Correct! You've found the flag.</p>
        ) : (
          <p className="text-red-500 mt-2">Incorrect. Try again.</p>
        )
      )}
    </div>
  );
};

export default SteganographyChallenge;
